<template>
  <div>
    <div class="refresh">
      <h-button type="primary" @click="getImagesList">
        <template #icon>
          <SearchOutlined />
        </template>
        {{ $t('text.reload') }}
      </h-button>
    </div>

    <div class="image__preview">
      <div class="img-list">
        <div v-for="file in fileList" :key="file.id" class="img-item">
          <a-image :src="file.imageUrl" style="width: 100%" />

          <div class="image-tag">
            <a-tooltip :title="$t('text.useImage')">
              <span @click="choiceFile(file)">
                <i class="fa-solid fa-images"></i>
              </span>
            </a-tooltip>

            <a-popconfirm
              :title="$t('message.confirmDelete')"
              :ok-text="$t('btn.ok')"
              :cancel-text="$t('btn.cancel')"
              @confirm="confirmEvent(file)"
            >
              <a-tooltip :title="$t('text.deleteImage')">
                <span>
                  <i class="fa-solid fa-trash-can"></i>
                </span>
              </a-tooltip>
            </a-popconfirm>
          </div>
        </div>
      </div>
    </div>

    <div class="paging-image">
      <a-pagination
        :current="page"
        :page-size="size"
        :total="total"
        :page-size-options="['8','12','24','36','50']"
        show-size-changer
        @change="handleCurrentChange"
        @showSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { SearchOutlined } from '@ant-design/icons-vue'
import { useI18n } from 'vue-i18n'
import { apiGetNoParam } from '@/api/index'
import { ECM_DELETE } from '@/api/const/file'
import messageShow from '@/utils/MessageShow'

interface Props {
  apiImages: any,
}

const props = withDefaults(defineProps<Props>(), {
  apiImages: '',
})

const emit = defineEmits(['close', 'choiceBanner'])

const { t } = useI18n()
const fileList = ref<any[]>([])
const page = ref(1)
const size = ref(8)
const total = ref(0)

onMounted(() => {
  getImagesList()
})

const getImagesList = async () => {
  const res: any = await apiGetNoParam(
    props.apiImages + '?page=' + page.value + '&size=' + size.value
  )

  const data = res.data.data
  fileList.value = data.body
  total.value = data.total || data.body.length
}

const deleteImage = async (id: any) => {
  const res: any = await apiGetNoParam(ECM_DELETE + id)
  const ok = res.data.data

  if (ok) {
    messageShow.success(t('text.deleteFile'), t('text.deleteFileSuccess'))
    removeFileById(id)
  } else {
    messageShow.error(t('text.deleteFile'), t('text.deleteFileFailed'))
  }
}

const removeFileById = (id: number) => {
  fileList.value = fileList.value.filter(item => item.id !== id);
};

const confirmEvent = (file: any) => {
  deleteImage(file.id)
}

const choiceFile = (file: any) => {
  emit('choiceBanner', file)
}

const handleSizeChange = (_: number, newSize: number) => {
  size.value = newSize
  getImagesList()
}

const handleCurrentChange = (newPage: number) => {
  page.value = newPage
  getImagesList()
}
</script>

<style scoped>
.refresh {
  padding-bottom: 15px;
}

.paging-image {
  display: flex;
  justify-content: center;
  padding: 15px;
}

.img-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, auto);
  gap: 10px;
}

.img-item {
  position: relative;
}

.image-tag {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
}

.image-tag span {
  padding: 5px;
  color: #fff;
}

.image-tag span i:hover {
  color: #e9c62b;
  font-size: 18px;
  cursor: pointer;
}
</style>
